import { createQuery } from '@luna/api';
import { CustomizationService } from '@api-client/products';
import { blobToBase64 } from '@luna/utils';

export const [
    useProductImage,
    { queryApiIfNeeded: getProductImage, invalidate: invalidateProductImage },
] = createQuery({
    payloadCreator: async (id: string) => {
        const blob = await CustomizationService.getPublicProductsCustomizationImage(
            { id },
            { skipParseJSON: true },
        );
        const byteArray = await blob.arrayBuffer();
        return blobToBase64(new Blob([byteArray]));
    },
    cacheKey: (id) => id,
    name: 'products/customization/images',
});
